import { Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { filter, map, mergeMap, pairwise, startWith, withLatestFrom } from "rxjs/operators";

import { LayoutFacadeService } from "./@core/components/layout/layout-facade.service";
import { MixpanelService } from "./@core/services/mixpanel.service";
import { NavigationFacadeService } from "./@core/services/navigation-facade.service";
import { SizeDetectorFacadeService } from "./@core/services/size-detector-facade.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	standalone: false,
})
export class AppComponent implements OnInit {
	showAppLoader$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	private urlAfterRedirects$: BehaviorSubject<string> = new BehaviorSubject("");
	private previousUrlAfterRedirects$: BehaviorSubject<string> = new BehaviorSubject("");
	private urlParams$: BehaviorSubject<any> = new BehaviorSubject(null);

	constructor(
		private screenFacade: SizeDetectorFacadeService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private navigationFacade: NavigationFacadeService,
		private mixpanelService: MixpanelService,
		private layoutFacade: LayoutFacadeService,
		private destroyRef: DestroyRef,
	) {
		// TODO: Setup information on document body
		// based on configurations (e.g. country,language)

		const screenWidth = document.body.clientWidth;
		this.screenFacade.setSize(screenWidth);
		this.showAppLoader$ = this.layoutFacade.showAppLoader$;
	}

	ngOnInit(): void {
		this.router.events
			.pipe(
				filter(event => {
					if (event instanceof NavigationEnd) {
						return true;
					}
					return false;
				}),
				startWith(null),
				pairwise(),
				map(([previousEvent, currentEvent]) => {
					this.urlAfterRedirects$.next(
						(currentEvent as NavigationEnd)?.urlAfterRedirects.split(";")[0],
					);
					this.previousUrlAfterRedirects$.next(
						(previousEvent as NavigationEnd)?.urlAfterRedirects.split(";")[0] ?? null,
					);
					return this.activatedRoute;
				}),
				map(route => {
					while (route.firstChild) {
						route = route.firstChild;
					}
					this.urlParams$.next(route.snapshot.queryParams);
					return route;
				}),
			)
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				filter(route => route.outlet === "primary"),
				mergeMap(route => route.data),
				withLatestFrom(
					this.previousUrlAfterRedirects$,
					this.urlAfterRedirects$,
					this.urlParams$,
				),
			)
			.subscribe(([, previousUrl, url]) => {
				this.mixpanelService.registerTabPageView(url);

				this.mixpanelService.registerPageView(previousUrl, url);

				// TODO: REMOVE UNNEEDED CODE AFTER NEW DESIGN
				this.navigationFacade.decideActiveMenuItem(url);
			});
	}
}
